import axios from "axios"

const API_URL = process.env.REACT_APP_API_URL || "http://meeting.daewoongai.com/api/";
const MAIL_API_URL = process.env.REACT_APP_MAIL_API_URL || "http://meeting.daewoongai.com/email/";

export const axiosMailInstance = axios.create({
    baseURL: MAIL_API_URL,
    withCredentials: true,
    headers: {
        "Content-Type": "application/json"
    }
})

export const axiosInstance = axios.create({
    baseURL: API_URL,
    withCredentials: true,
    headers: {
        "Content-Type": "application/json"
    }
})

export const axiosStringInstance = axios.create({
    baseURL: API_URL,
    withCredentials: true,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'text/plain'
    },
})

export const axiosPrivateInstance = axios.create({
    baseURL: API_URL,
    withCredentials: true,
    headers: {
        "Content-Type": "application/json"
    }
})

export const axiosFileInstance = axios.create({
    baseURL: API_URL,
    withCredentials: true,
    headers: {
        "Content-Type": "multipart/form-data"
    }
})